var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBlackPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.03711 0 3 4.03758 3 9C3 15.6397 11.3037 23.5312 11.6573 23.8643C11.7539 23.9546 11.877 24 12 24C12.123 24 12.2461 23.9546 12.3428 23.8643C12.6963 23.5312 21 15.6397 21 9C21 4.03758 16.9629 0 12 0ZM12 14C9.24314 14 6.99998 11.7569 6.99998 9C6.99998 6.24314 9.24319 3.99998 12 3.99998C14.7568 3.99998 17 6.24319 17 9C17 11.7568 14.7569 14 12 14Z",
    fill: "#4F565E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBlackPin);
export default __webpack_public_path__ + "static/media/AddressBlackPin.3dfaa6489c8d2481a76b3ab5ad94781f.svg";
export { ForwardRef as ReactComponent };